<div class="p-grid">
  <div class="p-col">
    <p-message severity="info" text="Para añadir items defínalos como   Clave|Valor  y un salto de línea por cada uno." class="p-d-block"></p-message>
  </div>
  <div class="p-col-12">
    <label for="items">Items</label><br>
    <textarea name="items" pInputTextarea [(ngModel)]="text"
              style="width: 100%; height: 360px; resize: none;"></textarea>
  </div>
  <div class="p-col-12 p-d-flex">
    <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary p-button-text" (click)="cancel()">
    </p-button>
    <p-button label="Guardar" icon="pi pi-check" styleClass="p-ml-2" (click)="save()">
    </p-button>
  </div>
</div>
